export const faqList = [
  {
    q: '茶杯狐影视这个页面主要提供什么？',
    a: '页面围绕「内容类型与剧集资源」组织信息，把电视剧、电影、热播剧与全集按分区呈现，并对资源与片源情况做一般性说明。它的定位是内容导航与信息浏览，帮助你先了解有哪些条目、属于什么类型、处在什么更新状态。',
  },
  {
    q: '热播剧的「更新中」和「已完结」有什么区别？',
    a: '「已完结」表示该剧的全部集数已经完整，适合一次连看；「更新中」表示剧集仍在陆续放出，卡片上会标注当前更新到的集数，方便你判断是否需要追更。两类条目都会在列表中明确标注。',
  },
  {
    q: '「全集」是什么意思，和普通单集有什么不同？',
    a: '这里的「全集」指按主题打包的整季条目集合，例如都市情感、悬疑推理等，一次给出同一主题下相对完整的剧集范围，便于按兴趣成组浏览，而不是分散地去逐条查找。',
  },
  {
    q: '片源与清晰度是如何区分的？',
    a: '页面按标清、高清、超清与 4K 四档说明片源，每档给出常见分辨率、码率范围、适用设备与观看建议。具体可用的清晰度会随片源情况变化，页面提供的是通用说明，便于你按设备与网络条件选择。',
  },
  {
    q: '页面上的搜索和类型筛选是怎么工作的？',
    a: '它们只作用于本页已经呈现的条目，属于本地筛选：输入关键词会按剧名匹配，点击标签会按类型过滤，结果实时更新并显示命中数量，不会向任何外部接口发送请求。',
  },
  {
    q: '为什么有些条目没有标注评分或年份？',
    a: '评分、年份等信息只有在能确认时才会展示。对于资料暂不完整的条目，页面会保留一般性说明而不做推测，避免把不确定的信息当作已确认的事实呈现。',
  },
];